import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {showAppLoader, hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import CompletedSuccessfulComponent from '../AbroadTicketBlock/CompletedSuccessfulComponent';



export const sendCouponsSms = createAsyncThunk(
  'couponComponent/sendCouponsSms',
  async (data, thunkAPI) => {
    try {
      thunkAPI.dispatch(showAppLoader());
      const result = await ProviderManager.getProviderData('sendCouponsSms',
        [
          data.templateName,
          data.isVoiceSms,
          data.primaryContactPhone,
          data.couponType,
          data.voucherParamList
        ]);
      return result.Body;
    } catch (error) {
      return error;
    }
    finally{
      thunkAPI.dispatch(hideAppLoader());
    }
  },
);

export const getKosherOrAflaloStatus = createAsyncThunk('Coupons/getKosherOrAflaloStatus', async (number, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('checkIsKosherOrAflaloNumber', [number]);
    thunkAPI.dispatch(hideAppLoader());
    return result;
  } catch (error) {
    return error;
  }
  finally{
    thunkAPI.dispatch(hideAppLoader());
  }
});

const initialState = {};

const CouponComponentSlice = createSlice({
  name: 'couponComponent',
  initialState: initialState,
  reducers: {},
  extraReducers: {},
});

export const {} = CouponComponentSlice.actions;
export default CouponComponentSlice.reducer;
